import React from "react";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";

function LockScreen() {
  return (
    // <div style={{backgroundColor:'#e9ecef'}}>
      // <div className="lockscreen" style={{height:'100vh'}}>
      <div className="lockscreen" style={{display:'flex',height:'100vh'}}>
        <div className="lockscreen-wrapper" style={{backgroundColor:'#e9ecef'}}>
          <div className="lockscreen-logo">
            <b>Jurni</b>HR
          </div>
          {/* <!-- User name --> */}
          <div className="lockscreen-name">Rajesh Pethkar</div>

          {/* <!-- START LOCK SCREEN ITEM --> */}
          <div className="lockscreen-item">
            {/* <!-- lockscreen image --> */}
            <div className="lockscreen-image">
              {/* <img src="../../dist/img/user1-128x128.jpg" alt="User Image" /> */}
              <img
                src="../../assets/adminlte/dist/img/rajesh_BW.jpg"
                alt="User Image"
              />
            </div>
            {/* <!-- /.lockscreen-image --> */}

            {/* <!-- lockscreen credentials (contains the form) --> */}
            <form className="lockscreen-credentials">
              <div className="input-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="password"
                />

                <div className="input-group-append">
                  <button type="button" className="btn">
                    <Link to="/home">
                      <i className="fas fa-arrow-right text-muted"></i>
                    </Link>
                  </button>
                </div>
              </div>
            </form>
            {/* <!-- /.lockscreen credentials --> */}
          </div>
          {/* <!-- /.lockscreen-item --> */}
          <div className="help-block text-center">
            Enter your password to retrieve your session
          </div>
          <div className="text-center">
            <a href="login.html">Or sign in as a different user</a>
          </div>
          <div
            className="lockscreen-footer text-center"
            style={{ display: "none" }}
          >
            Copyright &copy; 2014-2019
            <b>
              <a href="http://adminlte.io" className="text-black">
                AdminLTE.io
              </a>
            </b>
            <br />
            All rights reserved
          </div>
        </div>
      </div>
    // </div>
  );
}

export default LockScreen;
